import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { CompanyProfile, Event } from 'models';

import { useLocalEvent } from 'hooks/use-local-event';

type ReturnType =
    | {
          event: Event;
          booth: string;
      }
    | {
          event: undefined;
          booth: undefined;
      };

const useCompanyBooth = (company: Pick<CompanyProfile, 'id'>, event?: Event): ReturnType => {
    const { localEvent } = useLocalEvent();
    const searchable = event || localEvent;

    if (!searchable) {
        return { event: undefined, booth: undefined };
    }

    const companyWithBooth = CollectionHelpers.find(searchable.companies, company.id, 'company');

    if (!companyWithBooth) {
        return { event: undefined, booth: undefined };
    }

    return {
        event: searchable,
        booth: companyWithBooth.booth,
    };
};

export { useCompanyBooth };
